import { useEffect, useState } from "react";

/**
 * Ticks once a minute, for the reset countdown.
 *
 * A minute is the countdown's own resolution — anything faster re-renders for
 * no visible change.
 */
export const useNow = () => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(id);
  }, []);
  return now;
};
